import { Heading, Link, Text } from '@betterment/samba-react';

import { urlBuilder } from '~/b4b/utils/urlBuilder';

import { ErrorContent } from '../error-content/ErrorContent';

const FullPageErrorFallback = () => {
  return (
    <ErrorContent>
      <ErrorContent.Image />
      <ErrorContent.Header>
        <Heading as="h1">Unable to complete request</Heading>
      </ErrorContent.Header>
      <ErrorContent.Description>
        <Text>
          We're sorry, we're working to resolve this issue. Please try again later. If the issue continues,{' '}
          <Link href={urlBuilder.support()}>contact us</Link>.
        </Text>
      </ErrorContent.Description>
    </ErrorContent>
  );
};

export default FullPageErrorFallback;
